
import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  
  // Close mobile menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="container-custom py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-2">
          <img 
            src="/lovable-uploads/be1f07ad-0b0f-42a6-a096-054559dbb5f4.png" 
            alt="Frikopplad Logotyp" 
            className="h-8 w-auto" 
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-5 lg:space-x-6">
          <Link to="/" className={`text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/' ? 'text-frikopplad-red' : ''}`}>
            {t('navbar.home')}
          </Link>
          <Link to="/varfor" className={`text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/varfor' ? 'text-frikopplad-red' : ''}`}>
            {t('navbar.whySwitch')}
          </Link>
          <Link to="/alternativ" className={`text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/alternativ' ? 'text-frikopplad-red' : ''}`}>
            {t('navbar.alternatives')}
          </Link>
          <Link to="/resurser" className={`text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/resurser' ? 'text-frikopplad-red' : ''}`}>
            {t('navbar.resources')}
          </Link>
          <Link to="/fragor" className={`text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/fragor' ? 'text-frikopplad-red' : ''}`}>
            {t('navbar.faq')}
          </Link>
          <Link to="/om" className={`text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/om' ? 'text-frikopplad-red' : ''}`}>
            {t('navbar.about')}
          </Link>
          <Link to="/paket" className="btn-primary">
            {t('navbar.getStarted')}
          </Link>
          <LanguageSelector />
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center space-x-2">
          <LanguageSelector />
          <button
            onClick={toggleMenu}
            className="text-frikopplad-navy hover:text-frikopplad-red focus:outline-none"
            aria-label={isMenuOpen ? "Stäng meny" : "Öppna meny"}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 animate-fade-in">
          <div className="container-custom py-4 space-y-4">
            <Link 
              to="/" 
              className={`block text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/' ? 'text-frikopplad-red' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navbar.home')}
            </Link>
            <Link 
              to="/varfor" 
              className={`block text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/varfor' ? 'text-frikopplad-red' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navbar.whySwitch')}
            </Link>
            <Link 
              to="/alternativ" 
              className={`block text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/alternativ' ? 'text-frikopplad-red' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navbar.alternatives')}
            </Link>
            <Link 
              to="/resurser" 
              className={`block text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/resurser' ? 'text-frikopplad-red' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navbar.resources')}
            </Link>
            <Link 
              to="/fragor" 
              className={`block text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/fragor' ? 'text-frikopplad-red' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navbar.faq')}
            </Link>
            <Link 
              to="/om" 
              className={`block text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/om' ? 'text-frikopplad-red' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navbar.about')}
            </Link>
            <Link 
              to="/ordlista" 
              className={`block text-frikopplad-navy hover:text-frikopplad-red font-medium transition-colors duration-300 ${location.pathname === '/ordlista' ? 'text-frikopplad-red' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navbar.glossary')}
            </Link>
            <Link 
              to="/paket" 
              className="btn-primary w-full text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              {t('navbar.getStarted')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
